import { Box, HStack, Image, Text, VStack } from '@joinrepublic/dls-ui-kit';

import { IBusinessCase } from './types';

export interface IBusinessCaseProps {
  businessCase: IBusinessCase;
}

export const BusinessCase = ({ businessCase }: IBusinessCaseProps) => {
  const {
    company,
    title,
    categories,
    logoImage,
    backgroundImage,
    backgroundColor,
    facts,
    backedBy,
    variant,
  } = businessCase;

  return (
    <VStack
      as="article"
      w={{ base: '320px', sm: '380px' }}
      aspectRatio="380/530"
      p={{ base: '6', sm: '30px 30px 26px' }}
      borderRadius={{ base: 'lg', sm: 'xl' }}
      color={variant === 'dark' ? 'white' : 'black'}
      bgColor={backgroundColor}
      backgroundImage={`image-set(
        url(${backgroundImage.url}) 1x,
        url(${backgroundImage.url2x}) 2x
      )`}
      backgroundPosition="50% 100%"
      backgroundSize="contain"
      backgroundRepeat="no-repeat"
      justifyContent="space-between"
      align="start"
    >
      <VStack align="start" gap={{ base: '2', sm: '4' }}>
        <HStack as="p" gap="0" opacity="0.5">
          {categories.map((category) => (
            <Text
              key={category}
              as="span"
              size={{ base: 'body-xs', sm: 'body-sm' }}
              color="inherit"
              _notFirst={{
                _before: {
                  content: '"·"',
                  mx: '0.8em',
                },
              }}
            >
              {category}
            </Text>
          ))}
        </HStack>

        <Text
          as="h3"
          size={{ base: 'body-md', sm: 'body-lg' }}
          color="inherit"
          mr={4}
          sx={{
            textWrap: 'pretty',
          }}
        >
          {title}
        </Text>

        {facts && (
          <HStack gap="4">
            {facts.map((fact, index) => (
              <VStack key={index} align="start" gap={0} minW="98px">
                <Text size={{ base: 'body-md', sm: 'body-lg' }} color="inherit">
                  {fact.value}
                </Text>
                <Text
                  size={{ base: 'body-sm' }}
                  textStyle={{ sm: 'body-sm-md' }}
                  color="inherit"
                >
                  {fact.description}
                </Text>
              </VStack>
            ))}
          </HStack>
        )}

        {backedBy && (
          <VStack align="start" gap="0" mt="3">
            <Text size="body-sm" color="inherit" opacity="0.5">
              Backed by
            </Text>
            <HStack gap="5">
              {backedBy.map((backedByCompany, index) => (
                <Box key={index} as="figure">
                  <Image
                    src={backedByCompany.logo}
                    alt={`${backedByCompany.name} logo`}
                    height={{ base: '38px', sm: '45px' }}
                    filter={variant === 'light' ? 'invert(1)' : 'none'}
                  />
                </Box>
              ))}
            </HStack>
          </VStack>
        )}
      </VStack>

      <Box
        as="figure"
        borderRadius={{ base: 'lg', sm: 'xl' }}
        overflow="hidden"
        bg="white"
      >
        <Image
          boxSize={{ base: '50px', sm: '60px' }}
          src={logoImage}
          alt={`${company} logo`}
        />
      </Box>
    </VStack>
  );
};
